module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_m_normal.6d30c384.png";